import { render, staticRenderFns } from "./EditionStructureMenu.vue?vue&type=template&id=6e5615d5&scoped=true&"
import script from "./EditionStructureMenu.vue?vue&type=script&lang=js&"
export * from "./EditionStructureMenu.vue?vue&type=script&lang=js&"
import style0 from "./EditionStructureMenu.vue?vue&type=style&index=0&id=6e5615d5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5615d5",
  null
  
)

export default component.exports